import uniqueId from 'lodash.uniqueid';

var generateId = function generateId(propsId, idPrefix) {
  return propsId || uniqueId(idPrefix);
};

export default generateId;